import { DeploymentFrequency } from '@models/DF/df';

export class SetDF {
  static readonly type = '[DF] Set value';
  constructor(public deploymentFrequency: DeploymentFrequency) {}
}
